/*
 * AI 填表员入口（内部路由）
 *
 * 在 App.js 注册：<Route path="/ai/clerk" component={AIClerk} />
 *
 * 路由：
 *   /ai/clerk          → home（入口）
 *   /ai/clerk/work     → work（核心：左预览 + 右对话）
 */

import React, { useEffect } from 'react'
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom'
import Home from './home'
import HomeV2 from './home/HomeV2'
import HomeV3 from './home/HomeV3'
import Work from './work'
import { FileProvider } from './ctx/FileCtx'
import { CreditsProvider } from './ctx/CreditsCtx'
import { getValidToken } from './auth/tokenService'
import './index.scss'

// 首页默认全量 V3(双列工作台)。?v=1 → 旧 Home,?v=2 → HomeV2,
// 作为 V3 上线后的应急回退 / 内部对比通道(计划 2 周后单独 PR 物理删除 V1/V2)。
// 原 A/B 实验 AI_form_filling_master_abtest_v2 已下线(见 App.tsx),不再读 abTestConfig。
const HomeSwitch: React.FC = () => {
  const [searchParams] = useSearchParams()
  const v = searchParams.get('v')
  if (v === '1') return <Home />
  if (v === '2') return <HomeV2 />
  return <HomeV3 />
}

const AIClerk: React.FC = () => {
  // 进 /ai/clerk 立即换 cpu token（不等用户操作）；
  // 失败不阻断渲染，后续请求会再次重试
  useEffect(() => {
    getValidToken().catch((e) => {
      // eslint-disable-next-line no-console
      console.warn('[aiClerk] 首次 service-login 失败', e)
    })
  }, [])

  // 给 <body> 加 .aiClerk-active class, 用于 SCSS 局部覆盖全站 ant-layout-sider
  // 背景 (#F2F3F7 浅冷灰 → #FDFDFC 暖白, 跟主区域一致, 按设计稿). unmount 移除,
  // 不影响其他路由的 sider 样式.
  useEffect(() => {
    document.body.classList.add('aiClerk-active')
    return () => {
      document.body.classList.remove('aiClerk-active')
    }
  }, [])

  return (
    <FileProvider>
      <CreditsProvider>
        <Routes>
          <Route path="" element={<HomeSwitch />} />
          <Route path="work" element={<Work />} />
          <Route path="*" element={<Navigate to="/ai/clerk" replace />} />
        </Routes>
      </CreditsProvider>
    </FileProvider>
  )
}

export default AIClerk
